export const bzPartnerCategories = [
    {
        "id": "79679",
        "sponsorshipLevel": 9,
        "sponsorshipType": "SPONSOR",
        "heading": "Host Sponsors",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "79616",
        "sponsorshipLevel": 1,
        "sponsorshipType": "SPONSOR",
        "heading": "Platinum Sponsors",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "79615",
        "sponsorshipLevel": 8,
        "sponsorshipType": "SPONSOR",
        "heading": "Emerald Sponsors",
        "size": "lg",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "79632",
        "sponsorshipLevel": 2,
        "sponsorshipType": "SPONSOR",
        "heading": "Gold Sponsors",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "93890",
        "sponsorshipLevel": 3,
        "sponsorshipType": "SPONSOR",
        "heading": "Silver Sponsors",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "108531",
        "sponsorshipLevel": 11,
        "sponsorshipType": "SPONSOR",
        "heading": "GRIF Sponsors",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "88061",
        "sponsorshipLevel": 10,
        "sponsorshipType": "SPONSOR",
        "heading": "Supporters",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "135544",
        "sponsorshipLevel": 13,
        "sponsorshipType": "SPONSOR",
        "heading": "Arabic Business News Partner",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    },
    {
        "id": "80669",
        "sponsorshipLevel": 5,
        "sponsorshipType": "SPONSOR",
        "heading": "Media Partners",
        "size": "md",
        "__typename": "bizzaboSponsorCategories_BlockType"
    }
]


export const bzPartners = [
    {
        "level": 9,
        "description": "Abu Dhabi Convention and Exhibition Bureau’s main mission is to champion the emirate as a dynamic global business events leader. Since March 2013 it has driven and supported the development and promotion of business events throughout the emirate efficiently, effectively and transparently, and in partnership with all its stakeholders. ",
        "eventId": 443032,
        "created": "2022-12-19T10:17:07.000+0000",
        "twitter": "VisitAbuDhabi",
        "website": "https://visitabudhabi.ae/en/abu-dhabi-convention-and-exhibition-bureau",
        "visible": true,
        "facebook": "https://www.facebook.com/visitabudhabi",
        "linkedin": "https://www.linkedin.com/company/abudhabicb/?originalSubdomain=ae",
        "logo": "/legacy/ae/2023/partners/rxhxmliwsdkyihgx0ach",
        "name": "Abu Dhabi Convention & Exhibition Bureau",
        "id": 432189,
        "type": "SPONSOR"
    },
    {
        "level": 9,
        "description": "Miral is the leading creator of immersive destinations and experiences in Abu Dhabi, that contributes to the growth of the leisure, entertainment and tourism industry and Abu Dhabi’s economic diversification. It conceives, creates, operates, and manages immersive destinations and experiences that attract visitors from across the world to create unforgettable memories, accelerating the realisation of the Emirate’s tourism vision and growth.",
        "eventId": 443032,
        "created": "2022-12-19T10:17:46.000+0000",
        "twitter": "themiralgroup",
        "website": "https://miral.ae/",
        "visible": true,
        "facebook": "https://www.facebook.com/themiralgroup",
        "linkedin": "https://www.linkedin.com/company/themiralgroup/",
        "logo": "/legacy/ae/2023/partners/tkbiuf3lbytsx9szqvsp",
        "name": "Miral",
        "id": 432190,
        "type": "SPONSOR"
    },
    {
        "level": 9,
        "eventId": 443032,
        "created": "2022-12-19T10:18:37.000+0000",
        "twitter": "HiltonHotels",
        "website": "https://www.hilton.com/en/hotels/auhyihi-hilton-abu-dhabi-yas-island/",
        "visible": true,
        "facebook": "https://www.facebook.com/HiltonAbuDhabiYasIsland/",
        "linkedin": "https://www.linkedin.com/company/hilton-abu-dhabi-yas-island/?originalSubdomain=ae",
        "logo": "/legacy/ae/2023/partners/qxzlc0tdylkuphwcwvqr",
        "name": "Hilton Abu Dhabi Yas Island",
        "id": 432191,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "Accor is a world leading hospitality group offering experiences across more than 110 countries in 5 400 properties, 10 000 food & beverage venues, wellness facilities or flexible workspaces. The Group has one of the industry’s most diverse hospitality ecosystems, encompassing more than 40 hotel brands from luxury to economy, as well as Lifestyle with Ennismore.",
        "eventId": 443032,
        "created": "2022-11-17T17:28:50.000+0000",
        "twitter": "accor",
        "website": "https://group.accor.com/en",
        "visible": true,
        "facebook": "https://www.facebook.com/accor",
        "linkedin": "https://fr.linkedin.com/company/accor",
        "logo": "/legacy/ae/2023/partners/gfupciqjclf2tvwn6ty8",
        "name": "Accor",
        "id": 428273,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "Boutique Group is a hospitality company wholly owned by the Public Investment Fund (PIF), which aims to develop, manage and operate historical and cultural palaces in the Kingdom and transform them into ultra-luxury boutique hotels to revive the vibrant national heritage with the authentic culture of the Kingdom, and provide an exceptional and unique hospitality experience. In addition, the group translates the commitment of the Public Investment Fund to developing promising sectors in the Kingdom and contributing to the diversification of the Saudi economy.",
        "eventId": 443032,
        "created": "2023-01-11T05:54:16.000+0000",
        "twitter": "boutiquegroupsa",
        "website": "https://boutiquegroup.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/boutiquegroupsa/about/?viewAsMember=true",
        "customButtons": [
            {
                "name": "Instagram",
                "url": "https://www.instagram.com/boutiquegroupsa/"
            }
        ],
        "logo": "/legacy/ae/2023/partners/l8skqhv71qlrmcpxx56p",
        "name": "Boutique Group ",
        "id": 433757,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "Hilton (NYSE: HLT) is a leading global hospitality company with a portfolio of 22 world-class brands comprising nearly 7,300 properties and more than 1.1 million rooms, in 123 countries and territories. Dedicated to fulfilling its founding vision to fill the earth with the light and warmth of hospitality, Hilton has welcomed more than 3 billion guests in its more than 100-year history, earned a top spot on Fortune's 100 Best Companies to Work For list and been recognized as a global leader on the Dow Jones Sustainability Indices for six consecutive years. Hilton has introduced several industry-leading technology enhancements to improve the guest experience, including Digital Key Share, automated complimentary room upgrades and the ability to book confirmed connecting rooms. Through the award-winning guest loyalty program Hilton Honors, the more than 165 million members who book directly with Hilton can earn Points for hotel stays and experiences money can't buy. With the free Hilton Honors app, guests can book their stay, select their room, check in, unlock their door with a Digital Key and check out, all from their smartphone. Visit stories.hilton.com for more information, and connect with Hilton on Facebook, Twitter, LinkedIn, Instagram and YouTube. ",
        "eventId": 443032,
        "created": "2023-05-10T14:02:49.000+0000",
        "twitter": "HiltonHotels",
        "website": "https://www.hilton.com/en/corporate/",
        "visible": true,
        "facebook": "https://www.facebook.com/Hilton/",
        "linkedin": "https://www.linkedin.com/company/hilton/",
        "logo": "/legacy/ae/2023/partners/y1o5etmbcfsyfn9svheh",
        "name": "Hilton",
        "id": 454786,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "eventId": 443032,
        "created": "2023-03-01T11:31:54.000+0000",
        "twitter": "imkanproperties",
        "website": "https://www.imkan.ae/",
        "visible": true,
        "facebook": "https://www.facebook.com/IMKANProperties/",
        "linkedin": "https://www.linkedin.com/company/imkan-properties/",
        "logo": "/legacy/ae/2023/partners/p9lyzqprwyxawg1u8wuq",
        "name": "IMKAN",
        "id": 442184,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "eventId": 443032,
        "created": "2023-07-17T19:15:52.000+0000",
        "twitter": "Saudi_MT",
        "website": "https://mt.gov.sa/",
        "visible": true,
        "facebook": "https://www.facebook.com/Saudi.MT/",
        "linkedin": "https://www.linkedin.com/company/ministry-of-tourism-of-saudi-arabia/",
        "logo": "/legacy/ae/2023/partners/khkx9prmcchrw2lobed9",
        "name": "Ministry of Tourism - Saudi Arabia",
        "id": 469332,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "NEOM is The New Frontier. One of the last places on Earth waiting to be explored.\n\nRoam spaces unchartered, tread paths undiscovered, climb mountains uncovered, and swim in seas unspoilt, all brought to life and enjoyed in the most surprising of ways. Each tourism site of NEOM is a marvel of nature, a force of extraordinary beauty.\n\nInterwoven with nature, and advanced by technology, NEOM is pioneering a new way of living and new ways to travel and stay.",
        "eventId": 443032,
        "created": "2022-12-13T05:30:54.000+0000",
        "twitter": "NEOM",
        "website": "https://www.neom.com/en-us",
        "visible": true,
        "facebook": "https://www.facebook.com/discoverneom/",
        "linkedin": "https://www.linkedin.com/company/discoverneom/",
        "logo": "/legacy/ae/2023/partners/juou8byaebh6ropjvxue",
        "name": "NEOM",
        "id": 431610,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "Radisson Hotel Group is one of the world's largest hotel groups with nine distinctive hotel brands, and more than 1,700 hotels in operation and under development in 120 countries. The Group’s overarching brand promise is Every Moment Matters with a signature Yes I Can! service ethos. The Radisson Hotel Group portfolio includes Radisson Collection, Radisson Blu, Radisson, Radisson RED, Radisson Individuals, Park Plaza, Park Inn by Radisson, Country Inn & Suites by Radisson, and prizeotel brought together under one commercial umbrella brand Radisson Hotels.",
        "eventId": 443032,
        "created": "2022-11-29T22:39:06.000+0000",
        "twitter": "radissonhotels",
        "website": "https://www.radissonhotelgroup.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/RadissonHotels/",
        "linkedin": "https://www.linkedin.com/company/radisson-hotel-group/",
        "logo": "/legacy/ae/2023/partners/e3q2zy5d8fut7jobxaqz",
        "name": "Radisson Hotel Group ",
        "id": 430044,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "About Rua Al Madinah Holding\n\nA wholly-owned subsidiary of Saudi Arabia’s Public Investment Fund, Rua Al Madinah Holding undertakes holistic development projects that feature modern urban planning to elevate the experience of residents and visitors of Madinah, the home to countless Islamic monuments that tell the story of the Prophet (PBUH) and his revered companions. The company aims to elevate Madinah as a modern Islamic and cultural destination. With a capital of SAR3.918 billion, Rua Al Madinah Holding aims to develop a comprehensive hospitality and retail ecosystem that further enhances the inclusive and communal nature of Madinah. Through diverse development projects and an ultramodern infrastructure that enrich the experience of both residents and visitors, the company’s driving vision is to improve the quality of infrastructure and services according to the highest international standards.\n\nRua Al Madinah Holding’s strategy is fully aligned with the Public Investment Fund’s efforts to develop and enable promising sectors and help accomplish the Vision 2030 objective of bringing 30 million Hajj and Umrah pilgrims to the Kingdom by the year 2030.",
        "eventId": 443032,
        "created": "2023-02-22T14:34:07.000+0000",
        "twitter": "ruaalmadinah",
        "website": "https://ruaalmadinah.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/RuaAlmadinahHolding/",
        "linkedin": "https://www.linkedin.com/company/ruaalmadinah/",
        "logo": "/legacy/ae/2023/partners/ckfa30snj6qjeep6tv4u",
        "name": "Rua Al Madinah Holding",
        "id": 441054,
        "type": "SPONSOR"
    },
    {
        "level": 1,
        "description": "The collaboration between Next - an investment and development company, and Spectrum - an architectural firm, has resulted in a series of remarkable projects that exemplify their commitment to innovation and excellence. Their collaborative endeavors have not only borne impressive developments but have also given rise to comprehensive blueprints for future undertakings.\nTheir decision to unite in participation at the Future Hospitality Summit is a reflection of their shared vision and a commitment to presenting a harmonized perspective to the public. Their mission centers on crafting developments that carry enduring significance and are catalysts for positive societal transformation. \nBy showcasing their achievements and upcoming initiatives at the Future Hospitality Summit, Next and Spectrum aim to underscore their diligence, expertise, and capacity to leave a remarkable imprint on the hospitality industry. \nTheir collaborative efforts serve as a demonstration of the boundless potential that lies at the intersection of architecture and investment – where visionary projects are born, transcending the ordinary and fostering positive, lasting impacts on societies.\nSPECTRUM \nSpectrum is a fully integrated Design Build firm based in Tbilisi, Georgia, providing Architectural and Interior design services. Spectrum designs and builds unique and bespoke projects for commercial and residential sectors around the world. \nOur aim is to create long-lasting standards that integrate environmental impact with social and economic platforms, as well as global reach and local context. One of the key aspects and characteristics of our methodology is the deep understanding and consideration of the project location, its traditions, culture and surrounding context.\nWe relish the challenges inherent across a wide range of work, engaging our expertise and agility to deliver lasting and meaningful designs that bring value to our clients and contribute towards a healthier planet. \nNEXT \nNEXT Realty is the first Georgian based real estate developer announcing entrance in Dubai (Dubai Island). \nIn Georgia NEXT Realty is developing 5-star branded residences, culminating in fruitful collaborations with international hotel giants such as Radisson Hotel Group and Wyndham Hotels & Resorts.\nGoing beyond its branded residential portfolio, NEXT's sphere of influence encompasses the management and curation of high-end apart-hotels and villas meticulously designed to adhere to globally recognized standards. The company has developed premium infrastructure and hospitality services on the Black Sea coast in Georgia and boosted the profile of the location among tourists and investors worldwide. \nMarked by an unwavering commitment to unparalleled quality, NEXT's foundational principles are grounded in the understanding that a brand symbolizes an assurance of excellence. Across all endeavors, the company consistently directs its resources to ensure that each undertaking bears the hallmark of superior quality, consistently elevating its pursuit of excellence that defines the NEXT ethos.\nThe next stop for NEXT is Dubai Islands and its unique project NEXT Coral.\n",
        "eventId": 443032,
        "created": "2023-06-12T09:46:46.000+0000",
        "website": "https://nextrealty.ae/",
        "visible": true,
        "facebook": "https://www.facebook.com/nextgroup.ge",
        "linkedin": "",
        "logo": "/legacy/ae/2023/partners/xayjzdxegmoube1gcurq",
        "name": "Spectrum - Next ",
        "id": 460913,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "eventId": 443032,
        "created": "2023-09-07T16:46:33.000+0000",
        "twitter": "ASFARSaudi",
        "website": "http://asfar.com.sa/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/asfarsaudi/",
        "logo": "/legacy/ae/2023/partners/c02ito3zulipoishuqhr",
        "name": "ASFAR ",
        "id": 477272,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "description": "IHG Hotels & Resorts is one of the world’s leading hospitality companies with 6,000+ open hotels in over 100 countries and a purpose to provide True Hospitality for Good.\n\nThe company offers a portfolio of 19 diverse and well-loved brands across Luxury & Lifestyle, Premium, Essentials, Suites and Exclusive Partners, and IHG One Rewards, one of the world's largest hotel loyalty programmes.\n",
        "eventId": 443032,
        "created": "2023-02-22T14:32:47.000+0000",
        "twitter": "IHGhotels",
        "website": "https://www.ihgplc.com/en",
        "visible": true,
        "facebook": "https://www.facebook.com/ihghotels",
        "linkedin": "https://www.linkedin.com/company/ihghotels&resorts/",
        "logo": "/legacy/ae/2023/partners/gsxvth6oxxbzt8sppiua",
        "name": "IHG",
        "id": 441053,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "description": "Marriott International, Inc. (NASDAQ: MAR) is based in Bethesda, Maryland, USA, and encompasses a portfolio of nearly 8,600 properties under 31 leading brands spanning 139 countries and territories. Marriott operates and franchises hotels and licenses vacation ownership resorts all around the world. The company offers Marriott Bonvoy®, its highly awarded travel program. For more information, please visit our website at www.marriott.com.",
        "eventId": 443032,
        "created": "2023-01-24T11:50:45.000+0000",
        "twitter": "MarriottIntl",
        "website": "https://www.marriott.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/marriottinternational/",
        "linkedin": "https://www.linkedin.com/company/marriott-international/",
        "customButtons": [
            {
                "name": "Instagram",
                "url": "https://www.instagram.com/marriottintl/"
            }
        ],
        "logo": "/legacy/ae/2023/partners/q5far6ksaaqx6e5m9mq6",
        "name": "Marriott",
        "id": 435440,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "description": "Millennium Hotels & Resorts, Middle East & Africa currently operates over 50 hotels and 15,000 keys, in addition to 32 hotels in the development pipeline across the region. From a single property in Abu Dhabi, MHR Middle East & Africa has expanded into various neighbouring destinations, cultivating partnerships with reputable owners, and is now recognized as one of the fastest growing hotel management companies in the region.",
        "eventId": 443032,
        "created": "2023-03-01T11:25:29.000+0000",
        "twitter": "millennium",
        "website": "https://www.millenniumhotels.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/millenniumhotels",
        "linkedin": "https://www.linkedin.com/company/millennium-hotels-&-resorts/",
        "logo": "/legacy/ae/2023/partners/th8covjwu9mnsn4plrwa",
        "name": "Millennium Hotels & Resorts",
        "id": 442182,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "description": "Rotana currently manages a portfolio of over 100 properties throughout the Middle East, Africa, Eastern Europe, and Turkey, with an aggressive expansion plan in place. Rotana brands include, Rotana Hotels & Resorts, Centro Hotels by Rotana, Rayhaan Hotels & Resorts by Rotana, Arjaan Hotel Apartments by Rotana, The Residences by Rotana and the newly launched Edge by Rotana. Treasured Time. The Rotana promise to you.",
        "eventId": 443032,
        "created": "2023-01-27T12:02:10.000+0000",
        "twitter": "Rotana_Hotels",
        "website": "https://www.rotana.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/RotanaHotels",
        "linkedin": "https://www.linkedin.com/company/rotana/",
        "logo": "/legacy/ae/2023/partners/xdzsoodrvefrxaoiw02u",
        "name": "Rotana",
        "id": 436322,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "description": "The Moroccan Agency for Tourism Development – SMIT is a government institution created in December 2007 by the Moroccan government in order to implement the development strategy of the tourism offer in Morocco. In an increasingly competitive international context among tourism destinations where differentiation is getting tougher, investment attractiveness has become one of the major challenges tourism industries have to deal with. SMIT, therefore, puts investment promotion and capital raising at the heart of its concerns with an ambition to increase the profile and attractiveness of the Moroccan destinations it oversees. Designing the offer, identifying and highlighting tourism resources, mobilizing land, guiding public and private investment, supporting private investors and tour operators, facilitating their development in Morocco… These are at the core of SMIT involvement.",
        "eventId": 443032,
        "created": "2023-02-01T16:59:48.000+0000",
        "twitter": "SmitMorocco",
        "website": "https://smit.gov.ma/",
        "visible": true,
        "facebook": "https://www.facebook.com/smit.gov.ma/",
        "logo": "/legacy/ae/2023/partners/qk3d7vm5xuhqrlxi7ii4",
        "name": "SMIT ",
        "id": 437133,
        "type": "SPONSOR"
    },
    {
        "level": 8,
        "description": "Taiba Investment Company is a public joint-stock company listed on the Saudi Stock Exchange “Tadawul”. Established in 1988, Taiba manages a portfolio of diversified investments and has a distinguished history of investing in and developing iconic real estate projects, known for its commercial and hotel projects.",
        "eventId": 443032,
        "created": "2023-03-01T11:26:34.000+0000",
        "twitter": "taibainvest",
        "website": "https://www.taiba.com.sa/",
        "visible": true,
        "facebook": "https://www.facebook.com/taibainvest/",
        "linkedin": "https://www.linkedin.com/company/taibainvest/",
        "logo": "/legacy/ae/2023/partners/ylyza8hxacjnucnj2lco",
        "name": "Taiba Investments",
        "id": 442183,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Born and based in Dubai, Aleph Hospitality is the leading independent hotel management company in the Middle East and Africa. Trusted by the world’s leading brands, Aleph Hospitality manages hotels directly for owners, either on a franchise basis for branded properties or as a white label operator for independent hotels. Tailored-to-fit management solutions allow owners better control of their assets, clearer operational visibility and more contractual flexibility. Aleph Hospitality manages all aspects of hotel operations at any stage of development - from site and brand selection to technical assistance, pre-opening and day-to-day operations. Aleph Hospitality has earmarked a pipeline of 50 hotels in the Middle East and Africa by 2026. \n\nTo find out more, visit alephhospitality.com.  ",
        "eventId": 443032,
        "created": "2022-11-17T17:21:33.000+0000",
        "twitter": "Aleph_Hosp",
        "website": "https://www.alephhospitality.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/aleph-hospitality/",
        "logo": "/legacy/ae/2023/partners/omxaqprkrjvhp4r9fl9f",
        "name": "ALEPH",
        "id": 428267,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Amsa Hospitality is a Saudi Arabia-born hospitality group that brings centuries-old Arabian traditions of hospitality and generosity to the modern world. Our innovative mindset and commitment to Corporate Social Responsibility (CSR) and sustainability are keys to our success. A citizen company, Amsa Hospitality aims at addressing our industry post-COVID issues by partnering with key players while developing a groundbreaking midscale lifestyle Arabian hotel brand unique in many ways. True to Saudi Arabia’s Vision 2030, Amsa Hospitality actively supports the Kingdom’s goals. ",
        "eventId": 443032,
        "created": "2023-06-07T12:59:21.000+0000",
        "twitter": "HospitalityAmsa",
        "website": "http://www.amsahospitality.com",
        "visible": true,
        "facebook": "https://www.facebook.com/amsa.hospitality.7",
        "linkedin": "https://www.linkedin.com/company/amsa-hospitality/",
        "logo": "/legacy/ae/2023/partners/zavropkjr7xi88qcxnpt",
        "name": "AMSA Hospitality ",
        "id": 460275,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "CBRE is the world’s largest commercial real estate services and investment firm and has been serving clients in the Middle East for nearly twenty years. The company has more than 115,000 employees globally and over 1,300 professionals* in the Middle East operating out of 9 offices in 6 countries in the region. With services, insights and data that span every dimension of the industry, we create solutions for clients of every size and in every sector. Our specialists provide a fully-integrated suite of services across the region, including facilities, transaction and project management; cost management; property management; investment management; appraisal and valuation; property leasing; strategic consulting; property sales; mortgage services and development service. \n\nPlease visit our website at www.cbre.ae",
        "eventId": 443032,
        "created": "2023-02-23T12:48:26.000+0000",
        "twitter": "CBRE",
        "website": "https://www.cbre.ae/",
        "visible": true,
        "facebook": "https://www.facebook.com/cbre",
        "linkedin": "https://www.linkedin.com/company/cbre/",
        "logo": "/legacy/ae/2023/partners/ba3tuwvrqtpsniuvis0j",
        "name": "CBRE",
        "id": 441241,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2023-08-21T19:29:27.000+0000",
        "website": "https://www.tourisme.gov.mg",
        "visible": true,
        "facebook": "https://www.facebook.com/MinTour.MG",
        "linkedin": "https://mg.linkedin.com/company/minist%C3%A8re-du-tourisme-de-madagascar",
        "logo": "/legacy/ae/2023/partners/aceqelkfjkisypmtjnu7",
        "name": "Choose Madagascar",
        "id": 474017,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Colliers is a leading diversified professional services and investment management company. With operations in 65 countries, our 18,000 enterprising professionals work collaboratively to provide expert real estate and investment advice to clients. For more than 28 years, our experienced leadership with significant inside ownership has delivered compound annual investment returns of approximately 20% for shareholders. The hospitality & tourism division boasts a global network of specialist consultants in hotel, resort, serviced apartments, branded residences, marina, golf, leisure and spa sectors. Colliers is dedicated to providing strategic advisory services to investors, developers and institutions to extract the best value and potential from our client’s projects and assets.  With annual revenues of $4.5 billion and $98 billion of assets under management, Colliers maximizes the potential of property and real assets to accelerate the success of our clients, our investors, and our people. Learn more at corporate.colliers.com, Twitter @Colliers or LinkedIn.\n \n\nWith annual revenues of $4.5 billion and $81 billion of assets under management, Colliers maximizes the potential of the property and real assets to accelerate the success of our clients, investors, and people. Learn more at corporate.colliers.com, Twitter @Colliers, or LinkedIn. ",
        "eventId": 443032,
        "created": "2022-11-25T19:47:56.000+0000",
        "twitter": "Colliers",
        "website": "https://www.colliers.com/en",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/colliers-international/",
        "logo": "/legacy/ae/2023/partners/yocvgannxap1ihwxtqow",
        "name": "Colliers",
        "id": 429553,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Compass, a multi-award-winning project development solutions provider, offers fully tailored services with regional coverage to ensure a seamless journey for clients from initial concept to construction completion and handover. The highly skilled team intelligently navigates project challenges with core services that include Development Management, Programme Management, Project Management, Procurement Management, Commercial Services, and Construction Management. This comprehensive approach has garnered appreciation from clients across all sectors, with a specific speciality within hospitality, mixed-use, leisure and entertainment capital projects.",
        "eventId": 443032,
        "created": "2023-07-11T16:22:47.000+0000",
        "website": "https://compass-pc.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/compassprojectconsulting/",
        "linkedin": "https://www.linkedin.com/company/compass-project-consulting",
        "logo": "/legacy/ae/2023/partners/kdj7ucupvoq3epsujvd4",
        "name": "Compass Project Consulting",
        "id": 467908,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Elaf Group is a long-established leader in travel, tourism and hospitality. At home in Saudi Arabia, we are renowned for our range of award-winning hotels as well as our retail and corporate travel agency services. Internationally – across the Islamic nations – Elaf’s name is widely trusted as a leading operator of Hajj and Umrah services. ",
        "eventId": 443032,
        "created": "2022-11-30T16:34:43.000+0000",
        "twitter": "ElafGroup",
        "website": "https://elafgroup.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/elafgroup/",
        "logo": "/legacy/ae/2023/partners/xf3aozfwm3qdraswx5an",
        "name": "ELAF Group",
        "id": 430202,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Emaar Hospitality Group is the premier global provider of enriching, personal and memorable lifestyle experiences. It is a wholly-owned subsidiary of Emaar Properties PJSC, the Dubai-based global property developer, and manages Emaar’s hospitality and leisure projects across the region.\n\nDefining its competency in managing mixed-use property developments, Emaar Hospitality Group owns and manages a diversified portfolio of assets including distinctive global hotel brands: Address Hotels and Resorts, Palace Hotels and Resorts and Vida Hotels and Resorts, Rove Hotels and Armani Hotels and Resorts. An expert in design and technology, Emaar Hospitality Group has developed individual styles and ambiences for its hotels and resorts. \n\nEmaar Hospitality Group’s premium brand, Address Hotels and Resorts and Palace Hotels and Resorts provides an engaging and tailored experience. A home-grown statement of luxury, pushing the boundaries in the hospitality world, while creating the perfect setting for life’s precious moments. \n\nVida Hotels and Resorts is an upscale lifestyle hub where entrepreneurial and artistic minds can connect, create, relax and recharge. An inspiring yet understated place in the city’s hotspots for creators where simplicity meets design. \n\nAn established and renowned brand within the United Arab Emirates, Emaar Hospitality Group has begun to expand its operations outside of the UAE, opening its prestigious brands in Saudi Arabia, Egypt, Bahrain and Istanbul with ambitious plans to continue across the globe.\n\nEmaar Hospitality Group also boasts golf retreats, wellness club, a polo and equestrian club and  marina and yacht club. True to its promise to deliver memorable lifestyle experiences, Emaar Hospitality Group’s leisure clubs offer distinctive lifestyle experiences to golfing, equestrian and yachting communities. The leisure clubs, as part of Emaar Leisure Group, all enjoy excellent dining options and offer spectacular facilities for business and leisure alike.\n\nPlacing great importance on its food and beverage concepts, Emaar Hospitality Group creates culinary experiences, housing the talents of some of the world’s finest chefs. Living by a 360° food and beverage philosophy, the brand prides itself on its exemplary service, product, health and safety standards. \n\nUnderstanding that people are the most important element of the hospitality world, Emaar Hospitality Group places great emphasis on identifying and honing the skills of each associate at every hotel and resort through its Talent and Culture platform. Through its engaging HR practices, it consistently improves, nurtures, and develops the capabilities of its staff. \n\nInnovation is key for Emaar Hospitality Group, the forward-thinking organisation invests in pioneering marketing initiatives to stand apart from the industry, drawing on the expert knowledge and understanding of the globally savvy team, shaping innovative solutions to connect to more customers than before. It’s this pioneering attitude that ensures the focus on a constantly updated technological support network to provide a seamless and dynamic experience for both investors and guests. \n",
        "eventId": 443032,
        "created": "2023-03-01T11:42:26.000+0000",
        "website": "https://www.emaarhospitality.com/en/",
        "visible": true,
        "facebook": "https://www.facebook.com/EmaarHospitality/",
        "linkedin": "https://www.linkedin.com/company/emaar-hospitality-group/",
        "logo": "/legacy/ae/2023/partners/s0ceiknqkw8sn3pxubep",
        "name": "Emaar Hospitality",
        "id": 442185,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2022-11-24T02:05:34.000+0000",
        "twitter": "HVS_Consulting",
        "website": "https://www.hvs.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/hvs/",
        "logo": "/legacy/ae/2023/partners/irte0plsc5dgzc2aa0je",
        "name": "HVS",
        "id": 429385,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": " \nThe Indian Hotels Company Limited (IHCL) and its subsidiaries bring together a group of brands and businesses that offer a fusion of warm Indian hospitality and world-class service. These include Taj – the iconic brand for the most discerning travellers and ranked as India’s Strongest Brand 2023 as per Brand Finance; SeleQtions, a named collection of hotels; Vivanta, sophisticated upscale hotels; and Ginger, which is revolutionising the lean luxe segment.\n \nIncorporated by the founder of the Tata Group, Jamsetji Tata, the Company opened its first hotel - The Taj Mahal Palace, in Bombay in 1903. IHCL has a portfolio of 270 hotels including 79 under development globally across 4 continents, 11 countries and in over 100 locations. The Indian Hotels Company Limited (IHCL) is India’s largest hospitality company by market capitalization. It is listed on the BSE and NSE.",
        "eventId": 443032,
        "created": "2023-02-22T16:15:38.000+0000",
        "website": "https://www.ihcltata.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/the-indian-hotels-company-limited/",
        "logo": "/legacy/ae/2023/partners/us1teyujzxbdtxpdbttj",
        "name": "IHCL",
        "id": 441073,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Insignia Worldwide is powered by human ingenuity.\nFrom new economic mega-zones, real estate projects, hospitality or cultural venues to country pavilions and even corporate identities. We mine deep insights, decode cultures, shape trends, and pilot the headwinds of change to create places, spaces and experiences that enlighten and enrich the human spirit.\nWith over 20 years partnering with governments, sovereign funds, tourism boards and global brands in hospitality, Insignia Worldwide is the region's leading design, development, and experience company.\nWe go beyond all practical limitations to deliver breakthrough strategic and design solutions and achieve what is impossibly human.",
        "eventId": 443032,
        "created": "2022-11-17T17:18:19.000+0000",
        "twitter": "insigniaww",
        "website": "https://insigniaworldwide.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/Insigniaworldwide",
        "linkedin": "https://www.linkedin.com/company/insignia-worldwide-group/",
        "logo": "/legacy/ae/2023/partners/phzmcpa4xyhgnrbwpenf",
        "name": "Insignia",
        "id": 428266,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "About JLL \n                                                                                                                                                           \nFor over 200 years, JLL (NYSE: JLL), a leading global commercial real estate and investment management company, has helped clients buy, build, occupy, manage and invest in a variety of commercial, industrial, hotel, residential and retail properties. A Fortune 500 company with annual revenue of $20.9 billion and operations in over 80 countries around the world, our more than 103,000 employees bring the power of a global platform combined with local expertise. Driven by our purpose to shape the future of real estate for a better world, we help our clients, people and communities SEE A BRIGHTER WAY. JLL is the brand name, and a registered trademark, of Jones Lang LaSalle Incorporated. For further information, visit jll.com.\n \nAbout JLL MEA\n\nAcross the Middle East and Africa (MEA), JLL is a leading player in the real estate and hospitality services markets. The firm has worked in 35 countries across the region and employs over 1,650 internationally qualified professionals across its offices in Dubai, Abu Dhabi, Riyadh, Jeddah, Al Khobar, Cairo, Casablanca, Johannesburg and Nairobi. For further information, visit jll-mena.com.",
        "eventId": 443032,
        "created": "2023-01-17T12:17:57.000+0000",
        "twitter": "JLLMENA",
        "website": "https://www.jll-mena.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/jll",
        "linkedin": "https://www.linkedin.com/company/jll-mena/",
        "logo": "/legacy/ae/2023/partners/agcv66kqr5jfl51sxyok",
        "name": "JLL",
        "id": 434523,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Knight Frank delivers full scale Hospitality, Leisure and Tourism Advisory Services across the Middle East, with a proven track record regionally of hundreds of successful hospitality and tourism projects over the past 25 years. We specialise in every aspect of the hospitality, leisure and tourism sector, and offer a complete portfolio of advisory services.",
        "eventId": 443032,
        "created": "2023-03-02T14:39:42.000+0000",
        "twitter": "MENAKnightFrank",
        "website": "https://www.knightfrank.ae/",
        "visible": true,
        "facebook": "https://www.facebook.com/KnightFrankME",
        "linkedin": "https://www.linkedin.com/company/knightfrankmena/",
        "logo": "/legacy/ae/2023/partners/qqhhbbsiutpvul5hymni",
        "name": "Knight Frank",
        "id": 442749,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "We conceived LEVA Hotels as a lean hospitality management company, with a strong focus on converting and uplifting existing hotels into upscale, lifestyle properties with soft modifications. Unlike traditional large chains, LEVA provides innovative, flexible management solutions that are led by a team of entrepreneurial and 'hands-on' hoteliers whose sole aim is to deliver maximum financial returns to our owners, and consistency in guest satisfaction. The brand is strongly focused on growing in Africa, the Middle East, and Europe - mainly in Egypt, KSA, Morocco, Qatar, Oman, Sri Lanka, and Greece.",
        "eventId": 443032,
        "created": "2023-07-05T08:49:57.000+0000",
        "twitter": "levahotels",
        "website": "https://stayleva.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/LevaHotels/",
        "linkedin": "https://www.linkedin.com/company/leva-hotels-resorts/",
        "logo": "/legacy/ae/2023/partners/flv7stlj47re6chgmjtf",
        "name": "LEVA Hotels",
        "id": 466502,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Louvre Hotel Group / Golden Tulip – MENA, region is successfully operating it is more than 55 mid & upscale hotels/resorts in the Middle East region and Georgia. Currently, operating brands are Golden Tulip, Royal Tulip, Tulip Inn, and Campanile, and looking forward to opening 18 to 20 new hotels shortly in the region within 2022/2023 while introducing two new brands Tulip Residences and Kyriad.\n\nOur hotels and resorts are serving their guests from all segments and exceeding the guest expectations and the staff to ensure satisfactory and desired results for stakeholders. \n\nLouvre Hotels Group is considered one of the largest hotel groups in Europe and a top 5 global operator supported by its shareholder’s strength and size in the hotel industry. Under Jin Jiang’s ownership, Louvre Hotels Group is part of a platform, which includes more than 7,000 hotels and over 680,000 guest rooms in over 300 destinations.\n",
        "eventId": 443032,
        "created": "2022-11-17T17:26:27.000+0000",
        "twitter": "LouvreHotels",
        "website": "https://www.louvrehotels.com/en-us/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/louvre-h-tels/",
        "logo": "/legacy/ae/2023/partners/r948a0xk1ctr9vtmgsyo",
        "name": "Louvre Hotels Group ",
        "id": 428271,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Minor Hotels is an international hotel owner, operator and investor currently with more than 530 hotels in operation. Minor Hotels passionately explores new possibilities in hospitality with a diverse portfolio of properties designed intelligently to appeal to different kinds of travellers, serving new passions as well as personal needs. Through our Anantara, Avani, Oaks, Tivoli, M Collection, NH Collection, NH, nhow, Elewana, Marriott, Four Seasons, St. Regis, Radisson Blu and Minor International properties, Minor Hotels operates in 56 countries across Asia Pacific, the Middle East, Africa, the Indian Ocean, Europe, South America and North America.\n",
        "eventId": 443032,
        "created": "2022-11-17T17:28:04.000+0000",
        "website": "https://www.minorhotels.com/en",
        "visible": true,
        "facebook": "https://www.facebook.com/minorhotels",
        "linkedin": "https://www.linkedin.com/company/minor-hotel-group/",
        "logo": "/legacy/ae/2023/partners/ju1hksw9ntqokrbcfxgf",
        "name": "Minor Hotels ",
        "id": 428272,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "modDsys is a volumetric Modular Solutions company at the forefront of progress in construction. Our capabilities stretch across the entire process, from design to manufacture and project management and assembly. We utilise sophisticated, modern methods of Modular Solutions to build durable buildings of any design at any scale by deconstructing them into individual components or units, manufacturing them in our hi-tech facilities and assembling them at the building site to create long-standing, precisely constructed buildings that are aesthetically magnificent and ecologically positive. Our patented solutions are ushering in a bright new future where the dream of affordable, sustainable and enjoyable living is real. ",
        "eventId": 443032,
        "created": "2023-07-06T10:59:13.000+0000",
        "twitter": "modDsys_uae",
        "website": "https://moddsys.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/moddsysinc/",
        "linkedin": "https://www.linkedin.com/company/moddsys-modular-design-systems/",
        "logo": "/legacy/ae/2023/partners/lcakdat0wmm2f5bktvs5",
        "name": "ModDsys",
        "id": 466828,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "OBM International (OBMI) is a leading global master planning, architecture, and interior design firm that is widely celebrated for designing luxury resorts and hotels, bespoke private residences, and engaging urban areas. Since 1936, our approach has carefully distilled the essence of each place to create an authentic and unique destination.",
        "eventId": 443032,
        "created": "2023-06-20T20:53:23.000+0000",
        "twitter": "obmintl",
        "website": "https://obmi.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/obminternational/",
        "linkedin": "https://www.linkedin.com/company/obm-international/",
        "logo": "/legacy/ae/2023/partners/c3m0ng93ojz99zcwuacj",
        "name": "OBMI",
        "id": 464155,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "At PwC, our purpose is to build trust in society and solve important problems. We’re a network of firms in 152 countries with nearly 328,000 people who are committed to delivering quality in assurance, advisory and tax services. Find out more and tell us what matters to you by visiting us at www.pwc.com.\n\nEstablished in the Middle East for 40 years, PwC has 24 offices across 12 countries in the region with around 8,000 people. (www.pwc.com/me).",
        "eventId": 443032,
        "created": "2023-03-15T05:50:11.000+0000",
        "twitter": "PwC",
        "website": "https://www.pwc.com",
        "visible": true,
        "facebook": "https://www.facebook.com/PwC",
        "linkedin": "https://www.linkedin.com/company/pwc/",
        "logo": "/legacy/ae/2023/partners/dfm3c5jwwjfycyvxjezq",
        "name": "PWC",
        "id": 444897,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Creating the global travel industry’s top brands, QUO guides clients along their branding journey. Building brand equity and revenue, we initiate, fine-tune and implement original concepts. Whether branding nations, luxury hospitality giants, high-flying airlines, funky design hotels, adventurous travel companies or elegant boutique resorts, QUO brings ideas to life.\n",
        "eventId": 443032,
        "created": "2022-11-17T17:16:56.000+0000",
        "website": "https://www.quo-global.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/QUOGlobal",
        "linkedin": "https://www.linkedin.com/company/quoglobal/",
        "logo": "/legacy/ae/2023/partners/gjph4tg65x7atqfuaiqf",
        "name": "QUO",
        "id": 428265,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2023-02-10T14:11:37.000+0000",
        "website": "https://rikasgroup.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/rikas-hospitality-group/",
        "logo": "/legacy/ae/2023/partners/nfejfalvq1zfmmarebdj",
        "name": "Rikas Group",
        "id": 439455,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "Rove hotels is an award-winning lifestyle hotel and residences brand, offering well-designed properties in connected locations. Designed for those who like to explore without borders, receive fuss-free service and some touches of local culture. Rove Hotels defines a new niche in the ever-evolving global hospitality sector.\n \nRove Hotels are reliable, modern and efficient. Regardless of their location, Rovers (guests) will always find locally-inspired modern interiors, relaxed service and all the essentials to enjoy their stay. \n \nBorn in Dubai, Rove Hotels is a joint venture between Meraas Holding and Emaar Properties PJSC. \nThe first Rove hotel opened at Downtown Dubai in 2016 and the brand now has over 4000 hotel rooms and apartments open or under development across the Middle East. Rove Hotels continues to target properties in well-connected locations and further expansion announcements will follow soon.\n\nWebsite:  www.rovehotels.com \n@rovehotels\n",
        "eventId": 443032,
        "created": "2023-02-22T16:14:35.000+0000",
        "twitter": "RoveHotels",
        "website": "http://www.rovehotels.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/rovehotels/?ref=bookmarks",
        "linkedin": "https://www.linkedin.com/company/rove-hotels/",
        "logo": "/legacy/ae/2023/partners/nbxkgpfouvgrjd0t11m8",
        "name": "Rove Hotels",
        "id": 441072,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2023-09-06T12:51:24.000+0000",
        "twitter": "_Shurooq",
        "website": "https://shurooq.gov.ae/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/sharjah-investment-&-development-authority-shurooq-/",
        "logo": "/legacy/ae/2023/partners/pajsu5go0qvkw3pyros2",
        "name": "Sharjah Investment and Development Authority",
        "id": 477074,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "As a design-led consulting firm offering a 360-degree service from architecture to engineering and construction supervision, SSH has been a trusted partner of choice across the Middle East and Africa for over 62 years. With a reputation for design integrity and a portfolio that includes multiple landmark projects throughout the region, SSH maintains offices in Abu Dhabi, Dubai, Bahrain, Kuwait, London, Oman, Saudi Arabia, Egypt, Sub-Saharan Africa, Algeria, and North Africa.\n \nFounded in 1961, we employ over 800 high-calibre local, regional, and international experts in their individual fields, most of whom are from globally renowned international consulting firms. \n \nSSH has ranked within the top 10 Middle East architectural firms, as well as in infrastructure and construction management in the World Architecture 100 Survey in 2023. SSH was also ranked in 100th place among the ENR’s prestigious Top 225 International Design Firms for 2023.\n \nSSH's multifaceted practices include master planning, architecture, infrastructure, and construction supervision, as well as urban design and planning, landscape architecture, structural and civil engineering, MEP/building services, interior design, and project management.\n\n\nFounded in 1961, we employ approximately 800 high-calibre local, regional, and international experts in their individual fields, most of whom are from globally renowned international consultancy firms. SSH has been ranked in second position as architecture consultancy in the Middle East, among the top 100 architects in the world, in Building Design magazine’s World Architecture 100 Survey in 2023.\n\nWe were also ranked in 96th place among ENR’s Top 225 International Design Firms for 2022.  \n\nSSH's multifaceted practices include architecture, urban design and planning, landscape architecture, structural and civil engineering, MEP/building services, interior design, highway and bridge engineering, stormwater drainage, utility design, sanitary engineering, marine engineering, and district cooling, in addition to project management and construction supervision services. \n\nFor over 60 years, SSH has been committed to delivering architectural and engineering consultancy services across the MEA region. As a trusted partner of choice, SSH is determined to make a positive and sustainable impact on the future of the built environment across the Middle East and Africa.\n",
        "eventId": 443032,
        "created": "2023-01-10T06:31:03.000+0000",
        "twitter": "SSHDesign_",
        "website": "https://www.sshic.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/ssh-international/",
        "logo": "/legacy/ae/2023/partners/j2rwhamqhzjajeoarooh",
        "name": "SSH",
        "id": 433663,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "United Hospitality Management (UHM) is a global hotel franchise company operating across the Middle East and Europe, with 30+ years of luxury hospitality expertise having partnered with world-class brands including luxury collection by Marriott, Vignette Collection by IHG, Hyatt, Wyndham, Sheraton and Yotel. \n\nBacked by a multidisciplinary team with a track record of developing winning hospitality concepts across the world, UHM has emerged as a partner of choice for owners, developers, investors, and operators ready to achieve their hospitality investment goals.\n",
        "eventId": 443032,
        "created": "2023-03-31T14:54:52.000+0000",
        "website": "http://www.unitedhospitality.com",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/united-hospitality-mgmt/",
        "logo": "/legacy/ae/2023/partners/aijcqoodsngbg7qmpr6c",
        "name": "United Hospitality Management ",
        "id": 448039,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2023-07-17T19:46:11.000+0000",
        "website": "https://valorhospitality.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/valorhotels/",
        "linkedin": "https://www.linkedin.com/company/valor-hospitality-partners/",
        "logo": "/legacy/ae/2023/partners/j073nuek7wowdrzbbo03",
        "name": "Valor Hospitality Partners",
        "id": 469334,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "SHAPING TOMORROW’S TOURISM !\n\nFounded in 2006 in Paris, Voltere provides expert advice supporting the durable success of tourism projects. With multiple offices in Middle East, Africa, and France, we help our public and private sector clients create value and sustainability. Our team has been involved in hundreds of tourism, culture, leisure, and hotel-related projects for a large range of clients: governments, international institutions and donors, developers, lenders, investors, industrial corporations, and individually held businesses.  Voltere became a subsidiary of Egis in 2020.\n",
        "eventId": 443032,
        "created": "2022-12-13T05:26:05.000+0000",
        "twitter": "VolterebyEgis",
        "website": "https://voltere-consulting.com/en/home/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/volterebyegis/",
        "logo": "/legacy/ae/2023/partners/wiebg8tfe8mbm8y7qjho",
        "name": "Voltere",
        "id": 431609,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "description": "WhiteWater is the world’s leading designer and manufacturer of everything a water park needs. From design to the broadest product range in the industry, WhiteWater is recognized for their water slides, water rides, multi-level play structures, surf simulators, and wave systems.",
        "eventId": 443032,
        "created": "2022-12-19T18:03:13.000+0000",
        "twitter": "WhiteWaterWest",
        "website": "https://www.whitewaterwest.com/en/",
        "visible": true,
        "facebook": "https://www.facebook.com/WhiteWaterWest",
        "linkedin": "https://www.linkedin.com/company/whitewaterwest/?originalSubdomain=ca",
        "logo": "/legacy/ae/2023/partners/sfeui071g7yuxz9dbh8m",
        "name": "WhiteWater",
        "id": 432248,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2023-01-20T07:23:38.000+0000",
        "twitter": "WyndhamHotels",
        "website": "https://www.wyndhamhotels.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/wyndhamhotels/",
        "linkedin": "https://www.linkedin.com/company/wyndhamhotels/",
        "logo": "/legacy/ae/2023/partners/wyzobzjnzq7fhtxtoxqp",
        "name": "Wyndham Hotels ",
        "id": 434975,
        "type": "SPONSOR"
    },
    {
        "level": 2,
        "eventId": 443032,
        "created": "2023-08-07T11:33:05.000+0000",
        "twitter": "tourismzimbabwe",
        "website": "https://zimbabwetourism.net/",
        "visible": true,
        "facebook": "https://www.facebook.com/TourismZimbabwe/",
        "linkedin": "https://www.linkedin.com/company/zimbabwe-tourism-authority/?originalSubdomain=zw",
        "logo": "/legacy/ae/2023/partners/kvklg1j4vv7hnonhyqvu",
        "name": "Zimbabwe Tourism Authority ",
        "id": 471961,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "Action Hotels Company (AHC) is a subsidiary of Action Group Holding Company K.S.C.C (Kuwait) – “a diversified private Kuwait-based well established business conglomerates established in 1998”. Action Hotels Company is a leading Owner, Developer and Manager of 14 branded three- and four-star hotels with 2,500 rooms across Middle East and Australia.",
        "eventId": 443032,
        "created": "2023-09-06T15:48:53.000+0000",
        "twitter": "actionhotels",
        "website": "http://www.actionhotels.com/",
        "visible": true,
        "linkedin": "https://www.linkedin.com/company/action-hotels-plc/?originalSubdomain=ae",
        "logo": "/legacy/ae/2023/partners/npyijnm0knrzd8bf74be",
        "name": "Action Hotels Company",
        "id": 477083,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "Adyen (AMS: ADYEN) is the financial technology platform of choice for leading companies. By providing end-to-end payments capabilities, data-driven insights, and financial products in a single global solution, Adyen helps businesses achieve their ambitions faster. With offices around the world, Adyen works with the likes of Facebook, Uber, H&M, eBay, and Microsoft.",
        "eventId": 443032,
        "created": "2023-09-07T12:55:54.000+0000",
        "twitter": "Adyen",
        "website": "https://www.adyen.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/AdyenPayments/",
        "linkedin": "https://www.linkedin.com/company/adyen",
        "logo": "/legacy/ae/2023/partners/lht23oa7rkj2sjir1sg1",
        "name": "Adyen",
        "id": 477245,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "Aldar is a leading real estate developer, manager, and investor in the UAE. Through Aldar Hospitality, the company owns and manages a growing portfolio of hotels, beach clubs, golf courses, and marinas located in some of the most popular tourist destinations in the UAE. ",
        "eventId": 443032,
        "created": "2023-08-17T09:52:08.000+0000",
        "website": "https://www.aldar.com",
        "visible": true,
        "facebook": "https://www.facebook.com/aldar/",
        "linkedin": "https://www.linkedin.com/company/aldar_properties/?trk=ppro_cprof",
        "logo": "/legacy/ae/2023/partners/zeyzvjh0tilrjdushgf7",
        "name": "Aldar ",
        "id": 473352,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "Atmosphere Core offers world class hospitality through three distinctive leisure brands, THE OZEN COLLECTION, COLOURS OF OBLU, and Atmosphere Hotels & Resorts. Within 10 years, the company has launched 8 resorts in the Maldives and is set to further expand in South Asia and beyond.",
        "eventId": 443032,
        "created": "2023-08-11T16:04:45.000+0000",
        "website": "https://www.atmospherecore.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/atmospherecore/?_rdc=1&_rdr",
        "linkedin": "https://www.linkedin.com/company/atmospherecore/?originalSubdomain=mv",
        "logo": "/legacy/ae/2023/partners/rsifccwicojzx63ghfs0",
        "name": "Atmosphere ",
        "id": 472753,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "Setting standards since more than 90 years: Deutsche Hospitality delivers outstanding hospitality in over 130 hotels in Europe, Asia, and Africa. Eight distinctive brands, ranging from economy to luxury are unified under H Rewards, both seamless booking platform and loyalty program for more than 200 million loyalty members internationally. Deutsche Hospitality is part of Asian-based H World, one of the biggest and fastest-growing hotel groups in the world with a focus on digitization, technology, and innovation. \nSteigenberger Icons are extraordinary hotels juxtaposing historical uniqueness and state-of-the-art concepts. Steigenberger Porsche Design Hotels blend the distinctive Porsche Design lifestyle with hospitality and service. At Steigenberger Hotels & Resorts, visitors are treated to an unforgettable upscale hotel experience. Jaz in the City is a music centered lifestyle brand, always on point, lively and individual. Supporting local heroes, House of Beats is an innovative brand with an uncompromisable community approach. IntercityHotel is synonymous with flexible mobility and central locations, delivering high standards in design and comfort. MAXX by Deutsche Hospitality amplifies the essentials in the midscale area of the market. Zleep Hotels provide Danish design, quality, and Scandinavian simplicity at an affordable price. Book your stay at hrewards.com\n",
        "eventId": 443032,
        "created": "2023-02-15T11:32:36.000+0000",
        "twitter": "DEhospitality",
        "website": "https://www.deutschehospitality.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/deutschehospitality/",
        "linkedin": "https://www.linkedin.com/company/deutsche-hospitality/",
        "logo": "/legacy/ae/2023/partners/uermnicpvbcqg4vvtpdc",
        "name": "Deutsche Hospitality",
        "id": 440132,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "Hospitality Management Holding (HMH) is a fully integrated hotel management company and the strongest operator in the dry sector within the region. HMH provides hotel owners and developers with five distinct yet complementary hotel brands, ranging from luxury to lifestyle, which are Bahi Hotels & Resorts, Coral Hotels & Resorts, Corp Hotels, EWA Hotel Apartments, and ECOS Hotels.",
        "eventId": 443032,
        "created": "2022-11-17T17:24:51.000+0000",
        "twitter": "hmhhotelgroup",
        "website": "https://www.hmhhotelgroup.com/en",
        "visible": true,
        "facebook": "https://www.facebook.com/HMHhotelgroup/",
        "linkedin": "https://www.linkedin.com/company/hmhhotelgroup/",
        "logo": "/legacy/ae/2023/partners/ypbi5d85iyymd6h7gpoz",
        "name": "Hospitality Management Holding",
        "id": 428270,
        "type": "SPONSOR"
    },
    {
        "level": 3,
        "description": "A word meaning ‘cherished’ or ‘well-preserved’ in Arabic, Maknoon is a luxury homegrown brand dedicated to honoring the deep roots of Levantine culture through the use of olives and olive oil as a source of culinary joy and nostalgia.\n\nAt Maknoon, we celebrate the farmers who have lovingly made our artisan oils. By buying our products, you’re supporting them, their families and their communities. You become a part of their story and help in the preservation of their community.\n\nWe are passionate about the rich cultural heritage, from farm to table, and every experience in between. We are involved in every step of the process, from picking, to pressing, to bottling and delivering to your home or client.\n\nYou can be assured that you’re buying a product that has been ethically and sustainably produced by farmers whom we know and trust. We as a brand are committed towards delivering a positive footprint across our value chain.\n\nOur oils are lovingly crafted and beautifully presented, making them an exquisite gift, corporate spoil or equally a decadent addition to your own home.",
        "eventId": 443032,
        "created": "2023-08-17T10:26:48.000+0000",
        "website": "https://discovermaknoon.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/Discover-Maknoon-106767471189724",
        "logo": "/legacy/ae/2023/partners/acr7edmzmirg2uhcztba",
        "name": "Maknoon",
        "id": 473354,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "description": "You are invited to the FHS After Party, at Lock, Stock & Barrel Yas Bay, Abu Dhabi, hosted by Solutions Group. Following the FHS reception, join us in continuing the connections and kick back at the region’s most awarded party bar. With live music, mouthwatering bites and all the best in entertainment, as an FHS attendee, we’ll be kicking on with a private area and bar and the best stage views for all the action!",
        "eventId": 443032,
        "created": "2023-09-12T17:11:56.000+0000",
        "website": "https://lsbabudhabi.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/lockstockbarrelabudhabi",
        "logo": "/legacy/ae/2023/partners/bi8ipq9vuog4a8qvfsko",
        "name": "Lock, Stock & Barrel",
        "id": 478309,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "description": "LXA is a global, multi-disciplinary design company that provides a wide range of services, including interior design, design management, lead consultancy, project management, and cost consultancy, extending its support to both local and international designers alike. Established in London in 2000, the company has presence in London, Manchester, Dubai, Riyadh, and Bangalore and has completed over 1000 projects across hospitality, commercial, residential, and education sectors worldwide.",
        "eventId": 443032,
        "created": "2023-09-12T19:12:42.000+0000",
        "website": "https://crafthospitality.group/",
        "visible": true,
        "facebook": "https://crafthospitality.group/#",
        "linkedin": "https://www.linkedin.com/company/craft-hospitality-group/",
        "logo": "/legacy/ae/2023/partners/l8d97stbbjgydtxpo6bu",
        "name": "Craft Hospitality Group",
        "id": 478412,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "eventId": 443032,
        "created": "2023-07-06T11:27:06.000+0000",
        "website": "https://forsitecreative.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/Forsite-Creative-100757728571072/",
        "linkedin": "https://www.linkedin.com/company/forsite-creative/about/",
        "logo": "/legacy/ae/2023/partners/ufl2xsaaxgf6jjygitnr",
        "name": "Forsite Creative",
        "id": 466832,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "description": "For The Original Hot Chicken- The Original Hot Chicken [TOHC] is an American fast casual restaurant, specializing in Nashville-style hot chicken. Known for pickle-brined, southern-style, cornflake-rolled, damn-good chicken, coupled with a culinary-forward “Come Back” sauce that ranges in heat from Xtra hot to Korean to no heat at all.\n\nFor INKED Tacos- INKED Tacos is a Mexican-inspired fast-casual concept, made original and authentic by a community of chefs who have poured their cultural experiences into every dish, sourcing the ingredients that have indelibly INKED their rich legacies into a diverse, culinary-forward menu.  ",
        "eventId": 443032,
        "created": "2023-04-24T11:15:45.000+0000",
        "website": "https://www.frischs.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/dtfj2hdze0ulri6xkwpl",
        "name": "Frischs",
        "id": 452623,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "description": "Klimato is a carbon accounting software tailored for food-service businesses, facilitating measurement, tracking, and reduction of food-linked greenhouse gases. Klimato's mission is to educate chefs, and the public about food's climate impact through accessible data and clear communication, fostering sustainable choices.",
        "eventId": 443032,
        "created": "2023-08-24T19:36:38.000+0000",
        "website": "https://www.klimato.co/",
        "visible": true,
        "facebook": "https://www.facebook.com/Klimato/",
        "linkedin": "https://www.linkedin.com/company/klimato/",
        "logo": "/legacy/ae/2023/partners/eho9cocvshhh5j7if3ft",
        "name": "Klimato",
        "id": 474788,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "description": "Table and Beyond, established in 2016 in Dubai, is a dynamic and quality-focused company dedicated to providing exceptional hospitality solutions. We understand that the art of hospitality begins with captivating table settings and luxurious table linens. Our commitment to service, value, and quality shines through as we collaborate with renowned brands, supplying hotels and restaurants with a comprehensive range of products. With a team boasting extensive industry experience, we cater to the unique needs of the hospitality sector, ensuring every detail contributes to unforgettable guest experiences. Discover excellence in every aspect of hospitality with Table and Beyond.",
        "eventId": 443032,
        "created": "2023-09-06T12:10:32.000+0000",
        "website": "https://tableandbeyond.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/tableandbeyonduae/",
        "linkedin": "https://www.linkedin.com/company/table-and-beyond/",
        "logo": "/legacy/ae/2023/partners/gpzq6pt81dpzsm0bdsvn",
        "name": "Table & Beyond",
        "id": 477071,
        "type": "SPONSOR"
    },
    {
        "level": 11,
        "eventId": 443032,
        "created": "2023-06-12T18:35:09.000+0000",
        "twitter": "WinnowSolutions",
        "website": "https://www.winnowsolutions.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/winnowsolutions/",
        "linkedin": "https://www.linkedin.com/company/winnow-ltd-/?trk=company_logo",
        "logo": "/legacy/ae/2023/partners/hbrkbjynuw26lhh1gckr",
        "name": "Winnow",
        "id": 461055,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "description": "HAMA is the pre-eminent organization for hospitality asset managers, with their mission centered on the enhancement of hospitality asset managers through education, advancement of the profession, and serving as the collective industry voice of hospitality ownership. ",
        "eventId": 443032,
        "created": "2023-03-29T10:17:46.000+0000",
        "website": "https://www.hamamea.org/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/nsfd2nuanma9mzoddddd",
        "name": "HAMA MEA",
        "id": 447314,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "description": "Hotel Investment Conference - South Asia (HICSA 2023)\n",
        "eventId": 443032,
        "created": "2023-03-29T10:46:21.000+0000",
        "website": "https://www.hicsaconference.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/ykhndgpyrpep4of2pf76",
        "name": "HICSA 2023",
        "id": 447317,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "description": "Hotelivate is hospitality consulting firm offering its services to clients across the Asia-Pacific and Middle East Regions. It was founded by the erstwhile team of HVS India; Hotelivate, offers comprehensive consulting services through a diverse team of consultants who have a combined professional experience of over 250 years across various verticals in the hospitality industry.",
        "eventId": 443032,
        "created": "2023-03-29T10:46:53.000+0000",
        "website": "https://hotelivate.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/tqeaw9ido2rh1pc45se4",
        "name": "Hotelivate",
        "id": 447318,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "description": "We want to build a smart future. To achieve that, we’re building a unique ecosystem that connects change-makers and leading organizations.\n\nOur network consists of 50,000 startups, 500+ world-leading corporations, and hundreds of venture capital firms, universities, and government agencies across multiple industries. Together with our partners, we are creating a unique ecosystem designed to develop and implement the technologies of tomorrow.\n\nPlug and Play’s mission is to invest in 20 travel tech startups annually and bridge the gap between the innovators and industry leaders. ",
        "eventId": 443032,
        "created": "2023-02-07T18:56:45.000+0000",
        "website": "https://www.plugandplaytechcenter.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/iialyf2taoqkkekey6gc",
        "name": "Plug and Play",
        "id": 438158,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "eventId": 443032,
        "created": "2023-01-30T11:18:48.000+0000",
        "website": "https://sustainablehospitalityalliance.org/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/lfqqlc2cufbht0gwzatd",
        "name": "Sustainable Hospitality Alliance",
        "id": 436520,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "description": "The Sustainable Hospitality Challenge is a Hotelschool The Hague initiative that aims to enhance the evolution of sustainable hospitality, foster innovation driven by the leaders of tomorrow and nurture talent on a global scale by bringing it close to industry organizations who want to reimagine the future of hospitality.\n\nEstablished as a platform that challenges innovative hospitality approaches for the last seven years, SHC has evolved into a global knowledge-based initiative supported by the world’s best-known hospitality brands, global hospitality project developers, and smart cities.",
        "eventId": 443032,
        "created": "2023-02-07T07:55:17.000+0000",
        "website": "https://www.thestudentchallenge.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/epono37fcpjl1xrdn1rr",
        "name": "Sustainable Hospitality Challenge",
        "id": 438024,
        "type": "SPONSOR"
    },
    {
        "level": 10,
        "eventId": 443032,
        "created": "2023-07-11T16:33:35.000+0000",
        "website": "https://emiratesacademy.edu/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/gqreb2ioqbvp47q3dixg",
        "name": "The Emirates Academy of Hospitality Management",
        "id": 467914,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Arab News is Saudi Arabia's first English-language newspaper. It was founded in 1975 by Hisham and Mohammed Ali Hafiz. Today, it is one of 29 publications produced by Saudi Research & Publishing Company (SRPC), a subsidiary of Saudi Research & Media Group (SRMG). Faisal J. Abbas is the editor-in-chief.\n\nArab News is popular among many sections of Saudi society, including nationals and foreign residents, and from various socio-economic levels — guest workers to company CEOs. With such a large distribution and diverse group of readers, Arab News is the first choice among executives in local and foreign financial institutions. Because of its wide readership profile, the paper serves as a much sought-after medium for advertising and regional brand building. With the advent and growing popularity of the Internet as a source of information, the daily's website (www.arabnews.com) gets hundreds of thousands of hits every day from Web surfers worldwide.\n\nArab News was the first newspaper to provide a Saudi perspective in English on a wide range of national, regional and global issues through its diverse collection of columnists. This content keeps track of the Kingdom's policies and developments in Saudi society. Arab News is printed in color simultaneously at its state-of-the-art facilities in Jeddah, Riyadh and Dammam. It can be found on newsstands throughout the Middle East.",
        "eventId": 443032,
        "created": "2023-09-06T12:39:48.000+0000",
        "twitter": "arabnews",
        "website": "https://www.arabnews.com/",
        "visible": true,
        "facebook": "https://www.facebook.com/ArabNews/",
        "linkedin": "https://www.linkedin.com/company/arabnews/?viewAsMember=true",
        "customButtons": [
            {
                "name": "YouTube",
                "url": "https://www.youtube.com/channel/UCI8DegIWgK51cGakXcf1dOQ"
            },
            {
                "name": "Instagram",
                "url": "https://www.instagram.com/arabnews"
            }
        ],
        "logo": "/legacy/ae/2023/partners/cxyurqnocznoc17iqud6",
        "name": "Arab News",
        "id": 477073,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Breaking Travel News is the leading online resource for travel industry executives from around the world. From market intelligence, trend analysis and breaking news, to exclusive interviews, insightful features and perceptive videos, the site provides all the information insiders need to keep their fingers on the travel pulse. www.breakingtravelnews.com",
        "eventId": 443032,
        "created": "2023-01-19T13:12:00.000+0000",
        "website": "https://www.breakingtravelnews.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/taxwetabhqavqggjqu6l",
        "name": "Breaking Travel News",
        "id": 434829,
        "type": "SPONSOR"
    },
    {
        "level": 13,
        "description": "CNN Business Arabic provides Arabic speakers around the world with global and regional economic, business, and finance news, facts, and analysis to help them understand the business angle of regional and global news stories.\n\nLaunched in 2023, the dedicated digital business platform is operated by International Media Investments (IMI) in partnership with CNN International Commercial (CNNIC). Leveraging the digital knowledge within the IMI group and combining this with the brand recognition and newsgathering capabilities of CNN, CNN Business Arabic aims to become the most comprehensive, coherent, trusted, timely, and creative global source of Arabic-language business and economic news.\n\nDelivering breaking business news, insightful podcasts, and exclusive interviews with business leaders and influencers, the digital-first platform aims to inspire and empower current and future Arab business leaders and entrepreneurs in their daily quest for financial success, through engaging, visual, data-driven content.\n",
        "eventId": 443032,
        "created": "2023-09-11T09:52:57.000+0000",
        "website": "https://cnnbusinessarabic.com/",
        "visible": true,
        "customButtons": [
            {
                "name": "Learn more",
                "url": "https://cnnbusinessarabic.com/"
            }
        ],
        "logo": "/legacy/ae/2023/partners/ioadnpgeea0xu8izbcpo",
        "name": "CNN Business Arabic",
        "id": 477963,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Connecting Travel provides news, special reports, features, video content and creative solutions that inform, inspire, support and connect travel professionals at all levels throughout the Middle East with global markets. Connect with us for thought leadership, and for travel and hospitality news you can use, delivered via our free digital platforms, provided in English and Arabic, and at both virtual and face-to-face events, and bespoke brand training programmes.\n\nConnecting Travel is a division of the award-winning global Jacobs Media Group and as such has international reach through brands including the UK’s most influential B2B travel news resource, Travel Weekly; the UK’s longest-running hospitality title, The Caterer; luxury travel club and accompanying magazine Aspire; travel technology media leader Travolution; international events specialist Connections; the Global Travel Week trade fair; and the Global Travel & Tourism Resilience Council.",
        "eventId": 443032,
        "created": "2023-02-10T12:49:20.000+0000",
        "website": "https://www.connectingtravel.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/kjolaw0ej49wizqqiziv",
        "name": "Connecting Travel",
        "id": 439449,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Published monthly by JC Media Group, Economy Middle East magazine takes an independent and impartial approach to the latest news and insights into the economic sectors of the Middle East. \n\nAs the voice of the region’s economic sphere, we offer a fresh perspective on diverse topics, including Banking & Finance, Technology, Energy, Sustainability, Real Estate, Hospitality, Tourism, Socioeconomic affairs, as well as the business of sports, health, branding, and more. Our content includes analytical pieces by experts, investigative reports, and captivating business stories that keep our readers informed and engaged. \n\nAvailable in both English and Arabic, we feature C-level executives and key opinion leaders from the region and beyond. Our goal is to provide our readers with the latest insights and trends in the Middle East while offering an unbiased and balanced perspective on business opportunities that attract FDI and large investors.\n",
        "eventId": 443032,
        "created": "2023-06-26T06:42:21.000+0000",
        "website": "https://economymiddleeast.com/",
        "visible": true,
        "customButtons": [
            {
                "name": "Learn more",
                "url": "https://economymiddleeast.com/"
            }
        ],
        "logo": "/legacy/ae/2023/partners/bo1bwejhx1h3j8xgiz5u",
        "name": "Economy Middle East",
        "id": 464718,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Entrepreneur Middle East is the guide for the region's entrepreneurs and business-minded readership. It is the flagship publication of BNC Publishing, officially licensed by the US-based business and growth title, Entrepreneur. Launched in February 2014 together with its subsidiary, Entrepreneur Al Arabiya, Entrepreneur Middle East is now considered an authoritative read in the MENA region for business people, government entities, technology enthusiasts, and startup founders.",
        "eventId": 443032,
        "created": "2023-02-07T07:33:41.000+0000",
        "website": "https://www.entrepreneur.com/en-ae",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/quoste95eumwtaukcqbt",
        "name": "Entrepreneur Middle East",
        "id": 438020,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "EYE OF RIYADH provides effective digital marketing solutions for campaigns and events targeting Saudi Arabia and other GCC. \nwww.eyeofriyadh.com  is one of the most popular website in the GCC among citizen, residents , tourists and investors who are seeking for information and wish to explore the opportunities in the region. \nour services : \n•\tEmail and sms campaign\n•\tBanner advertising\n•\tSocial Media Campaign\n•\tEvents and Training Marketing\n•\tPublic Relations Services\t\n\nContact Eye of Riyadh: \nwww.eyeofriyadh.com \ninfo@eyeofriyadh.com \nTel: +966 11 2735522\n\n\nعين الرياض بوابة تسويقية لمدينة الرياض تخدم جميع شرائح المجتمع من مواطنين ومقيمين وسياح ومستثمرين، وتقدم العديد من الخدمات التفاعلية والأخبار والمعلومات المتنوعة والمحدثة يومياً باللغتين العربية والإنجليزية. وتدعم الفعاليات والأنشطة من خلال الرعاية والتنظيم والتسويق، كما تقدم خدمات تسويق إلكترونية. \nخدماتنا:\nتسويق  عبر حملات البريد الإلكتروني\nمساحات و بنرات إعلانية\nتسويق عبر وسائل الإعلام الاجتماعي\nتسويق الفعاليات والدورات التدريبية\nرسائل جوال نصية\nخدمات العلاقات العامة\nتصميم المواقع وتطوير الخدمات\nالإعلان، والتصميم الاحترافي\n\nللتواصل مع عين الرياض:\nwww.eyeofriyadh.com \ninfo@eyeofriyadh.com \nTel: +966 11 2735522\n",
        "eventId": 443032,
        "created": "2023-01-05T06:58:03.000+0000",
        "website": "http://www.eyeofriyadh.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/evvmtfxeni72buc3vr2t",
        "name": "Eye of Riyadh",
        "id": 433106,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "The Finance World Magazine is a MENA-based finance publication with a wide and influential audience from the industry. It provides essential news, data, and analysis for business sectors in the Middle East and beyond, ensuring readers stay up to date on industry developments. The magazine covers a diverse range of topics, including fintech, banking, stock market, digital assets, startups, trade, energy, entrepreneurship, mergers & acquisitions, healthcare, education, travel, and more. This broad scope enables us to cater to a diverse and prominent audience, delivering real value to our readers.",
        "eventId": 443032,
        "created": "2023-07-25T12:00:04.000+0000",
        "website": "https://thefinanceworld.com/",
        "visible": true,
        "customButtons": [
            {
                "name": "Learn more",
                "url": "https://thefinanceworld.com/"
            }
        ],
        "logo": "/legacy/ae/2023/partners/bt6aekj1arngcqemh36x",
        "name": "The Finance World",
        "id": 470311,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Creativity and industry involvement drives our future... Published for more than 20 years, Hospitality Net is regarded as a highly trusted source where industry leaders and experts go to learn, share and connect. Based on its proprietary publishing and syndication platform, Hospitality Net enables its members to reach and communicate with highly targeted audience groups in the global hospitality vertical.",
        "eventId": 443032,
        "created": "2023-01-23T10:59:21.000+0000",
        "website": "https://www.hospitalitynet.org/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/uufe2g0hhlvq8xlm2n8y",
        "name": "Hospitality Net",
        "id": 435202,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Hospitality News Middle East is the must-have regional bi-monthly trade magazine for the hospitality and foodservice industries. Discover the region’s new hotel projects, new restaurants, as well as industry solutions by the experts, in depth insight and interviews with the industry’s key players. There are country reports, expert interviews, regional news and much more. The buyers’ guide section features the latest products and services on the market, including food, beverage, equipment, technology and design, as well as the hospitality events happening across the region.",
        "eventId": 443032,
        "created": "2023-01-23T10:30:06.000+0000",
        "website": "https://www.hospitalitynewsmag.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/bljwu8ok2umnhkbqfewq",
        "name": "Hospitality News Middle East",
        "id": 435200,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "Hotel & Catering News Middle East is the region’s leading source for industry knowledge, bringing readers the latest in both fields. The publication, along with its digital platforms and large-scale events for professionals, offers in-depth insights into a wide variety of trends and topics that are relevant to today’s hoteliers, caterers, suppliers, experts and stakeholders.",
        "eventId": 443032,
        "created": "2023-02-07T07:34:39.000+0000",
        "website": "https://www.hotelnewsme.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/ifoy9dbxtdadmr5gzvis",
        "name": "Hotel & Catering News Middle East",
        "id": 438021,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "TravTalk is the only B2B trade media company in the UAE which has 3 mediums of publication. There is the monthly printed magazine – TravTalk, the news website Tourismbreakingnews.ae and a one-of-a-kind online news channel and App – TravelTV.News.\n\n They are a B2B print and electronic travel, tourism and hospitality trade magazine in the UAE with a presence of over twelve years in the region and over 25 years in India. Our circulation figures for the print version is over 150,000 readership with 25,000 monthly printed. TravTalk’s ME version is distributed all over the UAE and GCC to travel agents, tour operators, hotels, airlines and corporates etc.",
        "eventId": 443032,
        "created": "2023-07-13T04:24:40.000+0000",
        "website": "https://travtalkmiddleeast.com/",
        "visible": true,
        "customButtons": [
            {
                "name": "Learn more",
                "url": "https://travtalkmiddleeast.com/"
            }
        ],
        "logo": "/legacy/ae/2023/partners/kpgbbm9q4vhrnfb4psdf",
        "name": "TravTalk Middle East",
        "id": 468377,
        "type": "SPONSOR"
    },
    {
        "level": 5,
        "description": "TTN, the oldest most established (43 years) travel trade publication covering the tourism industry in the Middle East is aimed at travel professionals and provides in-depth - extensive coverage of relevant issues in the Middle East and Internationally. Printed and online editions plus daily E-newsletters provide an extensive readership profile.",
        "eventId": 443032,
        "created": "2023-01-13T09:08:01.000+0000",
        "website": "https://www.ttnworldwide.com/",
        "visible": true,
        "logo": "/legacy/ae/2023/partners/x1tuy3g8kba7n5biiotc",
        "name": "Travel & Tourism News (TTN) Middle East",
        "id": 433990,
        "type": "SPONSOR"
    }
]